import * as yup from "yup";
import { TFunction } from "i18next";

export const documentCreateValidation = (t: TFunction, isEdit: boolean) =>
  yup.object().shape({
    // Text inputs
    ...["name", "description", "signedBy"].reduce(
      (acc, el) => ({
        ...acc,
        [el]: yup
          .string()
          .required(t("validation.required"))
          .max(250, t("validation.more250")),
      }),
      {}
    ),

    // Select inputs
    ...["importance", "SubdivisionId", isEdit ? "" : "status"]
      .filter((el) => !!el)
      .reduce(
        (acc, el) => ({
          ...acc,
          [el]: yup.string().required(t("validation.required")),
        }),
        {}
      ),

    filesIds: yup
      .array()
      // .min(1, t("validation.required"))
      .required(t("validation.required")),
  });
